import { once } from 'lodash';
import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { CommerceComponentsDataInterface } from '@dutchiesdk/ecommerce-extensions-sdk';

import '@builder.io/widgets/dist/lib/builder-widgets-async';

export const registerCustomComponents = once(async (bridgeData: CommerceComponentsDataInterface) => {
  console.log('[builder] register components with:', bridgeData);

  Builder.registerComponent(
    dynamic(() => import('src/components/ctas').then((mod) => mod.LoginCta)),
    {
      name: 'Login CTA',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F6ac19e8ea77b468bb013fc36f36879ff%2F7eceed520a624c87b9551a58af83cbb1',
    }
  );
  Builder.registerComponent(
    dynamic(() => import('src/dispensary/core-menu/components/header/cart-button').then((mod) => mod.CartButton)),
    {
      name: 'Cart CTA',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F6ac19e8ea77b468bb013fc36f36879ff%2F7eceed520a624c87b9551a58af83cbb1',
    }
  );
  Builder.registerComponent(
    dynamic(() => import('src/dispensary/components/store-info/store-location-map').then((mod) => mod.default)),
    {
      name: 'Store Location Map',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F6ac19e8ea77b468bb013fc36f36879ff%2F7eceed520a624c87b9551a58af83cbb1',
    }
  );
  Builder.registerComponent(
    dynamic(() =>
      import('src/components/modals/chain-location-browser/chain-location-browser-content').then(
        (mod) => mod.ChainLocationBrowserContent
      )
    ),
    {
      name: 'Location Browser',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F6ac19e8ea77b468bb013fc36f36879ff%2F7eceed520a624c87b9551a58af83cbb1',
    }
  );
});
